<!--
 * @Author       : Tom
 * @Date         : 2019-12-16 10:19:24
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-20 16:34:07
 * @FilePath     : /shop_front_end/src/views/Home.vue
 * @Description  : 
 -->
<template>
  <a-layout id="components">
    <a-layout-sider width="160" :trigger="null" collapsible v-model="collapsed">
      <div class="logo">
        <div class="logo-title">赛尔玛特</div>
        <div class="logo-subhead">SALMART</div>
      </div>

      <a-menu theme="dark" mode="inline" v-model="defaultSelectedKeys" @click="onSelect">
        <a-menu-item key="1" data-path="/">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+homeImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+homeImg1+')'}" />
          <span>店铺首页</span>
        </a-menu-item>

        <a-menu-item key="2" data-path="/goodsmanage">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+goodsImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+goodsImg1+')'}" />
          <span>商品管理</span>
        </a-menu-item>

        <a-menu-item key="9" data-path="/inventory">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+kucunImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+kucunImg1+')'}" />
          <span>库存管理</span>
        </a-menu-item>

        <a-menu-item key="3" data-path="/ordermanage">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+orderImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+orderImg1+')'}" />
          <span>订单管理</span>
        </a-menu-item>

        <a-menu-item key="10" data-path="/SettlementOrder">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+couponImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+couponImg1+')'}" />

          <span>订单结算</span>
        </a-menu-item>

        <a-menu-item key="7" data-path="/coupon">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+couponImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+couponImg1+')'}" />

          <span>优惠券</span>
        </a-menu-item>

        <a-menu-item key="4" data-path="/fundmanage">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+moneyImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+moneyImg1+')'}" />

          <span>资金管理</span>
        </a-menu-item>

        <a-menu-item key="5" data-path="/clientmanage">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+kehuImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+kehuImg1+')'}" />

          <span>客户管理</span>
        </a-menu-item>

        <a-menu-item key="8" data-path="/stores">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+storeImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+storeImg1+')'}" />

          <span>公司办事处管理</span>
        </a-menu-item>

        <a-menu-item key="6" data-path="/shopset">
          <a-icon class="menuIcon" :style="{backgroundImage: 'url('+setImg+')'}" />
          <a-icon class="menuIcon menuIcon1" :style="{backgroundImage: 'url('+setImg1+')'}" />
          <span>店铺设置</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header class="menuhead">
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="()=> collapsed = !collapsed"
        />

        <div style="display: flex;align-items: center;">
          <div class="userBox">
            <a-avatar style="backgroundColor:#87d068" icon="user" v-if="!logo" />
            <a-avatar style="backgroundColor:#87d068" icon="user" v-else :src="logo" />

            <span class="username">{{ name || '暂无' }}</span>

            <img src="../assets/xiala.png" />

            <div class="userBoxHover">
              <ul>
                <li @click="toEdit('/shopset/editor','1')">
                  <img src="../assets/editStore.png" />
                  编辑信息
                </li>
                <li @click="toEdit('/shopset','2')">
                  <img src="../assets/editMima.png" />
                  修改密码
                </li>
              </ul>
            </div>
          </div>

          <img class="userlogout" src="../assets/logout.png" @click="onLogout" />
        </div>
      </a-layout-header>

      <div class="breadcrumbs" v-if="path != '/'">
        <a-breadcrumb :routes="routes">
          <template slot="itemRender" slot-scope="{route, params, routes, paths}">
            <span v-if="routes.indexOf(route) === routes.length - 1">{{route.breadcrumbName}}</span>

            <router-link v-else :to="`${ route.path }`">{{route.breadcrumbName}}</router-link>
          </template>
        </a-breadcrumb>
      </div>

      <a-layout-content
        :style="{ margin: path == '/'?'0':'0 16px 16px', background: path == '/'?'':'#fff', minHeight: '280px','border-radius':'4px'}"
      >
        <transition name="component-fade" mode="out-in">
          <router-view v-if="loadFlag" @changMenu="changMenu"></router-view>
        </transition>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>
<script>
import { clear } from "../lib/tool";
import { imgURL } from "../lib/config.js";

var deviceWidth;
setHtmlFontSize();

if (window.addEventListener) {
  window.addEventListener(
    "resize",
    function () {
      setHtmlFontSize();
    },
    false
  );
}
function setHtmlFontSize() {
  // 1920是设计稿的宽度，当大于1920时采用1920宽度，比例也是除以19.20
  deviceWidth =
    document.documentElement.clientWidth > 1920
      ? 1920
      : document.documentElement.clientWidth;
  document.getElementsByTagName("html")[0].style.cssText =
    "font-size:" + deviceWidth / 19.2 + "px !important";
}

export default {
  data() {
    return {
      collapsed: false, // 菜单收缩
      path: "/",
      routes: [],
      defaultSelectedKeys: [],
      name: "",
      logo: "",

      loadFlag: true,

      homeImg: imgURL + "images/icon1/mch/home.png",
      homeImg1: imgURL + "images/icon1/mch/homeh.png",
      goodsImg: imgURL + "images/icon1/mch/product.png",
      goodsImg1: imgURL + "images/icon1/mch/producth.png",
      kucunImg: imgURL + "images/icon1/mch/kucun.png",
      kucunImg1: imgURL + "images/icon1/mch/kucunh.png",
      orderImg: imgURL + "images/icon1/mch/order.png",
      orderImg1: imgURL + "images/icon1/mch/orderh.png",
      couponImg: imgURL + "images/icon1/mch/coupon.png",
      couponImg1: imgURL + "images/icon1/mch/couponh.png",
      moneyImg: imgURL + "images/icon1/mch/money.png",
      moneyImg1: imgURL + "images/icon1/mch/moneyh.png",
      kehuImg: imgURL + "images/icon1/mch/kehu.png",
      kehuImg1: imgURL + "images/icon1/mch/kehuh.png",
      storeImg: imgURL + "images/icon1/mch/store.png",
      storeImg1: imgURL + "images/icon1/mch/storeh.png",
      setImg: imgURL + "images/icon1/mch/set.png",
      setImg1: imgURL + "images/icon1/mch/seth.png",
    };
  },
  watch: {
    $route(to, from) {
      let { path, matched } = to;
      this.path = path;
      this.setBreadcrumb(matched);
    },
  },
  created() {
    this.initPages();
  },
  mounted() {
    let { path, matched } = this.$route;

    if (this.$route.query.token) {
      history.pushState(null, "", "#");
    }

    this.path = path;

    this.setDefaultSelectedKeys(matched);
    this.setBreadcrumb(matched);

    this.initPages();
  },
  methods: {
    toEdit(path, type) {
      this.defaultSelectedKeys = ["6"];

      if (type == 2) {
        localStorage.setItem("activeKey", "4");
      }
      this.$router.push(path);
    },
    changMenu(key) {
      this.defaultSelectedKeys = [key];
    },
    /**
     * @name 初始化页面
     */
    initPages() {
      this.$request.get("?module=pc_api&action=Mch&app=Index").then((res) => {
        let { code, meaasge, data } = res;

        if (code === 200) {
          if (data.length) {
            let {
              logo,
              name,
              realname,
              shop_information,
              shop_range,
              tel,
              address,
              ID_number,
            } = data[0];

            Object.assign(this, {
              name: name,
              logo: logo,
            });
          }
        } else {
        }
      });
    },
    /**
     * @name 设置面包屑
     * @param { matched | 路由栈 }
     */
    setBreadcrumb(matched) {
      let result = matched.filter((item) => {
        if (item.path != "" && item.meta.name) {
          return true;
        }
      });
      result = Array.from(result, (item) => {
        if (this.$route.matched[2].path == "/SettlementOrder/see") {
          return {
            path: item.path + "?sNo=" + this.$route.query.sNo,
            breadcrumbName: item.meta.name,
          };
        }

        return {
          path: item.path,
          breadcrumbName: item.meta.name,
        };
      });
      if (
        result.length > 1 &&
        result[0].path == "/goodsmanage" &&
        this.$route.query.commodity_type
      ) {
        let breadcrumbName =
          this.$route.query.commodity_type == 0 ? "实物商品" : "服务类商品";
        let path = "/goodsmanage";
        if (this.$route.query.commodity_type == 1) {
          path = "/goodsmanage?tab=4";
        }
        result.splice(1, 0, {
          breadcrumbName: breadcrumbName,
          path: path,
        });
      }
      this.routes = result;
    },
    /**
     * @name 菜单默认选中
     */
    setDefaultSelectedKeys(matched) {
      for (let item of matched) {
        if (item.meta.index) {
          this.defaultSelectedKeys.push(item.meta.index);
        }
      }
    },
    /**
     * @name 菜单被选中
     * @param { item | Object } 调用参数
     */
    onSelect(item) {
      let menulist = [
        "ant-menu-item ant-menu-item-active",
        "ant-menu-item ant-menu-item-active ant-tooltip-open",
        "ant-menu-item ant-menu-item-selected",
        "ant-menu-item ant-menu-item-active ant-menu-item-selected",
      ];

      this.loadFlag = false;

      console.log(this.defaultSelectedKeys);
      console.log(item);
      if (item.domEvent.path) {
        let list = item.domEvent.path.filter((item) =>
          menulist.includes(item._prevClass)
        );
        if (list.length) {
          let { path } = list[0].dataset;
          this.$router.push(path);
        }
      } else {
        let path = item.item.$el.dataset.path;
        this.$router.push(path);
      }

      setTimeout(() => {
        this.loadFlag = true;
      }, 0);
    },
    /**
     * @name 登出
     * */
    onLogout() {
      clear();
      this.$router.push("/login");
    },
  },
};
</script>
<style lang="less">
.ant-layout {
  height: 100vh;
  overflow-y: hidden;

  .ant-layout {
    height: 100%;
  }
}
#components {
  min-height: 100vh;
  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .trigger:hover {
    color: #03a2f4;
  }

  .logo {
    height: 64px;
    background: #008aea;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;

    &-title {
      font-size: 26px;
      font-weight: 400;
      color: #fefeff;
    }

    &-subhead {
      font-size: 9px;
      font-weight: 400;
      color: #fefeff;
      letter-spacing: 3px;
    }
  }

  .menuhead {
    background: #fff;
    padding: 0;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);

    display: flex;

    justify-content: space-between;

    > div {
      padding: 0 36px;

      .userBox {
        display: flex;
        align-items: center;
        margin-right: 43px;
        padding: 0 0 0 14px;
        cursor: pointer;
        position: relative;

        .ant-avatar {
          width: 30px;
          height: 30px;
        }

        .username {
          margin: 0px 5px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(65, 70, 88, 1);
        }

        .userBoxHover {
          position: absolute;
          bottom: -76px;
          right: 0;
          padding-top: 4px;
          z-index: 9999;
          display: none;

          ul {
            display: flex;
            flex-direction: column;
            list-style: none;
            padding: 5px 0 3px;
            margin: 0;
            width: 120px;
            height: 72px;
            background: #ffffff;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
            border-radius: 4px;

            li {
              flex: 1;
              display: flex;
              align-items: center;
              overflow: hidden;
              padding: 0 12px;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #6a7076;

              img {
                margin-right: 12px;
              }
            }

            li:hover {
              background-color: rgba(3, 162, 244, 0.08);
            }
          }
        }
      }

      .userBox:hover .userBoxHover {
        display: block;
      }
    }
  }

  .breadcrumbs {
    height: 26px;
    display: flex;
    align-items: center;
    padding-left: 16px;
    margin: 8px 0px;
  }

  .userlogout {
    width: 19px;
    height: 20px;
    cursor: pointer;
  }
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
  opacity: 0;
}

.maskNew {
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  display: block;
}
/* 添加属性弹窗 */
.maskNewContent {
  width: 460px;
  height: 250px !important;
  margin: 0 auto;
  position: relative;
  font-size: 18px;
  top: 200px;
  background: #fff;
  border-radius: 4px;
  padding-top: 10px;
  box-sizing: border-box;
}
.maskContent {
  height: 50px;
  position: relative;
  top: 50px;
  padding: 0 80px;
  font-size: 16px;
  text-align: center;
}
.maskbtn {
  text-align: center;
  margin-top: 104px;
  display: flex;
  justify-content: space-evenly;
}
.mask-content {
  display: flex;
  flex-direction: column;
  padding-top: 0;
  width: 680px;
  height: 510px !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0 !important;
}
.mask-title {
  line-height: 58px;
  border-bottom: 2px solid #e9ecef;
  font-size: 16px;
  color: #414658;
  font-weight: bold;
  padding-left: 19px;
  margin-bottom: 0;
}
.mask-content-data {
  padding: 40px 40px 0;
  overflow: hidden;
  flex: 1;
}
.mask-content-data > div {
  display: flex;
}
.shooser_attrDiv {
  width: 520px;
  height: 272px;
  background: #f4f7f9;
  margin-top: 10px;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 15px;
  box-sizing: border-box;
  font-size: 14px;
}
.shooser_attrDiv select {
  width: 240px;
  height: 36px;
  font-size: 14px;
  color: #414658 !important;
  border: 1px solid rgba(180, 180, 180, 0.4);
}
.shooser_attrDiv > div {
  display: flex;
  align-items: center;
}
.shooser_attrDiv ul,
.shooser_attrDiv label {
  margin-bottom: 0;
}
.shooser_attrDiv ul {
  width: 100%;
  max-height: 171px;
  position: absolute;
  background: #ffffff;
  border: 1px solid #d3dae3;
  border-top: 0;
  overflow-y: auto;
  background: #ffffff;
  z-index: 99;
  list-style: none;
  padding-left: 0;
}
.shooser_attrDiv li {
  height: 34px;
}
.shooser_attrDiv li:hover {
  background: #f4f7f9;
}
.shooser_attrDiv li > label {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}
.attr_title {
  width: 90px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2890ff;
  border-radius: 2px;
  color: #2890ff;
  position: relative;
  margin: 20px 0;
  background: #ffffff;
}
.attr_title img {
  position: absolute;
  right: 0;
  top: 0;
  width: 12px;
  height: 12px;
}
.attr_content {
  display: flex;
  flex-wrap: wrap;
}
.attr_content label {
  margin-right: 20px;
  margin-bottom: 10px;
}
.custom_attrDiv .left_text {
  display: inline-block;
  width: 70px;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom_attrDiv[class] input[type="text"] {
  padding-left: 10px;
  border: 1px solid rgba(180, 180, 180, 0.4) !important;
  height: 36px;
}
.custom_attrDiv a.addBtn,
.custom_attrDiv a.removeBtn {
  display: inline-block;
  width: 88px;
  height: 36px !important;
  box-sizing: border-box;
  line-height: 34px;
  text-align: center;
  margin-left: 10px;
  box-sizing: border-box;
}
.custom_attrDiv a.addBtn {
  color: #2890ff;
  border: 1px solid #2890ff;
}
.custom_attrDiv a.removeBtn {
  color: #828b97;
  border: 1px solid #828b97;
}
.custom_attrVlue {
  flex-wrap: wrap;
}
.custom_attrVlue a {
  display: flex;
  align-items: center;
  height: 36px;
  padding: 0 10px;
  background: #ffffff;
  color: #414658;
  border: 1px dashed #b2bcd1;
  margin-bottom: 10px;
  margin-right: 10px;
}
.custom_attrVlue a img {
  width: 12px;
  height: 12px;
  margin-left: 10px;
}

.mask-bottom {
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #e9ecef;
  margin-top: auto;
}
.mask-bottom input[type="button"] {
  width: 112px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  margin: 16px 0;
  border: 0;
  outline: 0;
  cursor: pointer;
}
.mask-bottom input[type="button"]:first-child {
  border: 1px solid #2890ff;
  color: #2890ff;
  margin-right: 10px;
  background: #ffffff;
}
.mask-bottom input[type="button"]:last-child {
  background: #2890ff;
  color: #ffffff;
  margin-right: 20px;
}
.closeA {
  position: absolute;
  right: 10px;
  top: 15px;
  width: 30px;
  height: 30px;
  color: #eee;
}
label,
.placeholder {
  font-size: 14px;
}
.mask-content-data .radio {
  margin-right: 10px;
}

.menuIcon {
  width: 16px;
  height: 16px;
  background-position: center;
  background-size: 16px 16px;
  background-repeat: no-repeat;
}

.menuIcon1[class] {
  display: none;
}

.ant-menu-item-active .menuIcon,
.ant-menu-item-selected .menuIcon {
  display: none !important;
}

.ant-menu-item-active .menuIcon1,
.ant-menu-item-selected .menuIcon1 {
  display: inline-block !important;
}

.ant-switch-checked {
  background-color: #03a2f4 !important;
}

.ant-btn-primary[class] {
  background-color: #03a2f4;
  border-color: #03a2f4;
}

.ant-btn-primary[class]:hover,
.ant-btn-primary[class]:focus {
  background-color: #03a2f4;
  border-color: #03a2f4;
  opacity: 0.7;
}

.ant-tabs-nav .ant-tabs-tab-active[class] {
  color: #03a2f4 !important;
}

.ant-tabs-ink-bar[class] {
  background-color: #03a2f4 !important;
}

.ant-btn-background-ghost.ant-btn-primary[class] {
  color: #03a2f4;
  background-color: transparent;
  border-color: #03a2f4;
}
.ant-btn-background-ghost.ant-btn-primary[class]:hover,
.ant-btn-background-ghost.ant-btn-primary[class]:focus {
  color: #03a2f4;
  background-color: transparent;
  border-color: #03a2f4;
  opacity: 0.7;
}
</style>